var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"bid",class:_vm.bidClasses},[_c('span',{staticClass:"level"},[_vm._v(_vm._s(this.bid.level))]),(this.bid.strain == 'notrump')?_c('span',{staticClass:"strain notrump"},[_vm._v("NT")]):_c('SuitDisplay',{staticClass:"strain",attrs:{"suit":this.bid.strain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }